import React, { useState } from 'react';
import AppHeader from '../../components/Header/Header';
import AppLayout from '../../components/layout';
import BannerSection from '../../components/BannerSection';
import Accordion from 'react-bootstrap/Accordion';
import SidebarMenu from '../../components/SidebarMenu';
import SectionHeading from '../../components/SectionHeading'; 
import BreadcrumbNav from '../../components/BreadcrumbNav';

const caminho = [
    { label: 'Home', href: '/', icon: 'bi bi-house-door' },
    { label: 'Instituição' },
    { label: 'FAQ' }
];

function Perguntas_Frequentes() {
  const [activeKey, setActiveKey] = useState("0");

  const toggleKey = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  const faqData = [
    {
      key: "0",
      question: "Quais são os cursos oferecidos e como posso saber se o curso que quero está disponível?",
      answer:
        "Licenciatura em Direito, Relações Internacionais, Pedagogia, Psicologia, Sociologia, Gestão de Empresa, Gestão de Recursos Humanos, Contabilidade, Economia, Enfermagem, Análises Clínicas, Engenharia Informática, Engenharia Civil, Farmácia e Fisioterapia.",
    },
    {
      key: "1",
      question: "Quais são os requisitos de admissão e o processo de inscrição para ingressar no Instituto?",
      answer:
        "O processo envolve a apresentação de documentos pessoais, certificado de conclusão do ensino médio, preenchimento do formulário de inscrição e pagamento da taxa. Mais detalhes podem ser encontrados na nossa página de admissões.",
    },
    {
      key: "2",
      question: "Quais oportunidades de estágio ou colocação profissional estão disponíveis durante o curso?",
      answer:
        "Os alunos têm acesso a estágios em empresas parceiras, instituições públicas e ONGs, com apoio do nosso gabinete de inserção profissional.",
    },
    {
      key: "3",
      question: "Quais são as instalações e recursos disponíveis para os alunos, como laboratórios, bibliotecas e serviços de apoio?",
      answer:
        "Oferecemos bibliotecas modernas, laboratórios de informática, laboratórios de ciências biomédicas, salas de estudo, apoio psicológico e acesso à internet.",
    },
    {
      key: "4",
      question: "Como é o corpo docente deste instituto? Eles têm experiência prática relevante em suas áreas de ensino?",
      answer:
        "Sim. Nosso corpo docente é composto por professores com elevada formação acadêmica e sólida experiência profissional nas suas áreas.",
    },
  ];

  return (
    <>
      <header id='header'>
        <AppHeader />
      </header>
      <BannerSection
        title="FAQ – Perguntas e Respostas"
        subtitle="Perguntas Frequentes sobre o Instituto Superior Politécnico Atlântida"
        description={`Encontre respostas para as perguntas mais comuns sobre o Instituto Superior Politécnico Atlântida, desde cursos oferecidos até requisitos de admissão e oportunidades de estágio.`}
        backgroundImage={require('../../assets/BannerANU_ispa.jpg')} 
        backgroundId="instituition-Banner"
        />
      <BreadcrumbNav items={caminho} />
      <br />
      <style>
        {`
          .faq-item .accordion-button {
            background-color: #f8f9fa;
            font-size: 1rem;
            border-radius: 0.5rem;
            transition: all 0.3s ease;
          }
          .faq-item .accordion-button:not(.collapsed) {
            background-color: #e6f4ea;
            color: #14532d;
            box-shadow: inset 0 -1px 0 rgba(0,0,0,.125);
          }
          .faq-item .accordion-button::after {
            transform: rotate(90deg);
            transition: transform 0.3s ease;
          }
          .faq-item .accordion-button.collapsed::after {
            transform: rotate(0deg);
          }
          .faq-item .accordion-body {
            font-size: 0.95rem;
            color: #4a4a4a;
          }
        `}
      </style>

      <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
        <br />
        <div className="row flex-row-reverse">
          <div className="col-12 col-md-4 col-lg-3 col-xl-2">
              <SidebarMenu
                  title="Instituição"
                  items={[
                  { label: "Apresentação", href: "/instituicao" },
                  { label: "Palavras do Presidente", href: "/instituicao/palavra-do-presidente" },
                  { label: "Organigrama", href: "/instituicao/organigrama" },
                  { label: "Legalidade", href: "/instituicao/legalidade" },
                  { label: "Missão, Visão e Valores", href: "/instituicao/missao-visao-valores" },
                  { label: "Apoio Social", href: "/instituicao/apoio-social" },
                  { label: "Perguntas Frequentes", href: "/instituicao/perguntas-frequentes" },
                  { label: "Decretos", href: "/instituicao/decretos" },
                  { label: "Regulamento", href: "/instituicao/regulamentos" },
                  ]}
              />
              </div>
          <div className="col-12 col-md-8 col-lg-9 col-xl-9 col-xxl-9">
            <br />
            <SectionHeading title="Perguntas Frequentes" />
            <Accordion activeKey={activeKey}>
              {faqData.map(({ key, question, answer }) => (
                <Accordion.Item
                  eventKey={key}
                  key={key}
                  className="faq-item shadow-sm mb-3 border-0 rounded"
                >
                  <Accordion.Header onClick={() => toggleKey(key)}>
                    <span className="fw-medium">{question}</span>
                  </Accordion.Header>
                  <Accordion.Body>{answer}</Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>
        <br />
        <br />
        <br />
      </main>
      <AppLayout />
    </>
  );
}

export default Perguntas_Frequentes;
